import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import OptionsBlockRow from "../OptionsBlockRow";
import ErrorMessage from "../../Shared/ErrorMessage";
import Markdown from "../../Shared/Markdown";
import Modal from "../../Shared/Modal";
import SenderList from "../../Shared/SenderList";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { OptionsBlockRow, Markdown, ErrorMessage, Modal, SenderList },
  setup() {
    // injects
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    // variables, computed
    const error = ref<string|null>(null);
    const channelsWanted = ref(false);
    const senderListVariantId = ref<number | null>(null);
    const optionVariants = computed(() => {
      const variants = orderService?.availableVariants?.value?.filter(
        (v) => v.product_id == productId,
      );
      return variants ?? [];
    });
    const productId: number = 10;
    const vatType = computed(() => {
      return orderService?.currentVatType.value;
    });

    // Methods
    const channelWantedToggle = async () => {
      if (false == channelsWanted.value) {
        const toRemove =
          orderService?.currentItems?.value?.filter(
            (it) => it.product_id == productId,
          ) ?? [];
        for (let i = 0; i < toRemove.length; i++) {
          await orderService?.removeFromCart(
            toRemove[i].product_variant_id,
            "",
            toRemove[i].qty,
          );
        }
      }
    };
    const isInCart = (variantId: number) => {
      const foundVariant = orderService?.currentItems.value.find(
        (it) => it.product_variant_id == variantId,
      );
      return typeof foundVariant !== "undefined";
    };

    const toggleVariant = async (variantId: number) => {
      try {
        if (!isInCart(variantId)) {
          await orderService?.addToCart(variantId, "", 1);
        } else {
          await orderService?.removeFromCart(variantId, "", 1);
        }
      } catch (err) {
        error.value = `${err}`;
      } 
    };

    const openSenderList = (variantId: number) => {
      senderListVariantId.value = variantId;
    };
    const closeSenderList = () => {
      senderListVariantId.value = null;
    };

    onMounted(() => {
      const hasChannels =
        orderService?.currentItems?.value?.filter(
          (it) => it.product_id == productId,
        ).length ?? 0;
      if (0 < hasChannels) {
        channelsWanted.value = true;
      }
    });

    return {
      error,
      channelsWanted,
      channelWantedToggle,
      isInCart,
      toggleVariant,
      optionVariants,
      priceFormatter,
      vatType,
      t,
      senderListVariantId,
      openSenderList,
      closeSenderList,
    };
  },
} as any);
